module.exports = __webpack_public_path__ + "static/media/backToAllUsers.e3ca3069.svg";